// API Configuration
export const API_URL = process.env.API_URL || 'https://vieon-api.lumination.vn';

// Get the selected profile ID from localStorage
export const getSelectedProfileId = () => localStorage.getItem('selectedProfileId');

// Get the authenticated user data from localStorage
export const getAuthUser = () => {
  const authUser = localStorage.getItem('authUser');
  return authUser ? JSON.parse(authUser) : null;
};

// Get the user ID from localStorage
export const getUserId = () => {
  const authUser = getAuthUser();
  return authUser?.userId || null;
};

// Clear all authentication data
export const clearAuthData = () => {
  localStorage.removeItem('authUser');
  localStorage.removeItem('selectedProfileId');
};

// Check if user is authenticated
export const isAuthenticated = () => !!getAuthUser();
